<script setup lang="ts">
import { ref, nextTick } from 'vue';
import ModalConfirm from 'components/ModalConfirm/index.vue';
import type { PickerInstance } from 'vant';

export interface ModalSelectExpose {
  open: (value: string) => void;
}

const props = defineProps<{
  title?: string;
  columns: Array<any>;
  visibleItemCount?: number;
  columnsFieldNames?: any;
}>();

const emit = defineEmits(['confirm', 'cancel']);

const confirmModal = ref<any>();
const pickerRef = ref<PickerInstance>();

const defaultFieldNames = { text: 'text', value: 'value', children: 'children' };

const onCancel = () => {
  emit('cancel');
};

const onConfirm = () => {
  emit('confirm', pickerRef.value?.getValues());
};

defineExpose<ModalSelectExpose>({
  open: async (value?: string) => {
    confirmModal.value?.open();
    await nextTick();
    if (value) {
      pickerRef.value?.setColumnValue(0, value);
    }
  },
});
</script>

<template>
  <ModalConfirm
    ref="confirmModal"
    :hidden-cancel="true"
    @confirm="onConfirm"
    @cancel="onCancel"
  >
    <div :class="$style.title">
      {{ props.title }}
    </div>
    <van-picker
      ref="pickerRef"
      :columns="props.columns"
      :show-toolbar="false"
      :columns-field-names="props?.columnsFieldNames || defaultFieldNames"
      :visible-item-count="props.visibleItemCount"
    />
  </ModalConfirm>
</template>

<style lang="less" module>
@import 'style/vars.less';

.title {
  font-size: 40px;
  color: #1F2933;
  font-weight: 700;
}
</style>
